import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AverageStoreOpinionsDTO, StoreOpinionDetailsDTO } from '../type';

export interface SatisfactionState {
  entities: AverageStoreOpinionsDTO[];
  selectedStoreOpinions: StoreOpinionDetailsDTO[];
  isLoading: boolean;
  hasError: boolean;
  filters: {
    includeDisabled: boolean;
  };
}

const initialState: SatisfactionState = {
  entities: [],
  selectedStoreOpinions: [],
  isLoading: false,
  hasError: false,
  filters: {
    includeDisabled: false,
  },
};

export const { actions, reducer } = createSlice({
  name: 'satisfaction',
  initialState,
  reducers: {
    setAverageStoreOpinions: (state, action: PayloadAction<AverageStoreOpinionsDTO[]>) => {
      state.entities = action.payload;
      state.hasError = false;
    },
    setStoreOpinions: (state, action: PayloadAction<StoreOpinionDetailsDTO[]>) => {
      state.selectedStoreOpinions = action.payload;
      state.hasError = false;
    },
    setSatisfactionLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setSatisfactionError: (state, action: PayloadAction<boolean>) => {
      state.hasError = action.payload;
    },
    setFilters: (state, action: PayloadAction<Partial<SatisfactionState['filters']>>) => {
      state.filters = {
        ...state.filters,
        ...action.payload,
      };
    },
  },
});
